import { ChatMessage } from '@farol-ds/react'
import { ReactNode, useEffect } from 'react'

import styles from './static-chat-messages.module.scss'

export interface StaticChatMessagesProps {
  messages: {
    role: 'user' | 'assistant'
    content: string | ReactNode
  }[]
  onDisplayMessages?: () => void
}

export function StaticChatMessages(props: StaticChatMessagesProps) {
  const { messages, onDisplayMessages } = props

  useEffect(() => {
    if (onDisplayMessages) {
      onDisplayMessages()
    }
  }, [onDisplayMessages])

  return (
    <div className={styles.container}>
      {messages.map(({ role, content }, idx) => (
        <ChatMessage key={idx} from={role === 'user' ? 'me' : 'other'}>
          {role === 'assistant' && (
            <ChatMessage.Header>
              <ChatMessage.HeaderLabel>Resposta gerada pelo Jus IA</ChatMessage.HeaderLabel>
            </ChatMessage.Header>
          )}
          <ChatMessage.Body>
            <ChatMessage.Content>
              {typeof content === 'string' ? (
                <article dangerouslySetInnerHTML={{ __html: content }} />
              ) : (
                content
              )}
            </ChatMessage.Content>
          </ChatMessage.Body>
        </ChatMessage>
      ))}
    </div>
  )
}
